import { Pipe, PipeTransform } from '@angular/core';
import { SimpleOrderItem } from '../interfaces/simple-order-item.interface';

@Pipe({
  name: 'ticketInfoFromSimpleOrderItem'
})
export class TicketInfoFromSimpleOrderItemPipe implements PipeTransform {

  transform(orderItem: SimpleOrderItem, includePrice: boolean = true): string {
    let ticketInfo: string = orderItem.ticketPrice.vehicleType.description;

    if (includePrice) {
      ticketInfo += `, ${orderItem.price} kr`;
    }

    if (orderItem.ticketPrice.ticketType.description === 'Klippkort') {
      ticketInfo += ` (Klippkort ${orderItem.ticketPrice.quantity}st)`;
    }
    else if (orderItem.ticketPrice.ticketType.description === 'Enkelresa') {
      ticketInfo += ' (Enkel)';
    }
    else {
      ticketInfo += ` (${orderItem.ticketPrice.ticketType.description})`;
    }

    return ticketInfo;
  }

}
